const linq = require('linq');

module.exports = function () {
    global = typeof global != "undefined" && global || window;

    //字符串
    {
        String.prototype.format = function () {
            var values = arguments;
            return this.replace(/\{(\d+)\}/g, function (match, index) {
                if (values.length > index) {
                    return values[index];
                } else {
                    return "";
                }
            });
        };
        String.prototype.toJSON = function (isthrow = false) {
            if (this.length == 0 && isthrow) throw new Error('空字符串错误');
            let json_data = '';
            try {
                if (typeof eval != 'undefined') json_data = eval('(' + this + ')');
                else json_data = JSON.parse(this);

                if (typeof json_data != 'object') {
                    json_data = '';
                    throw '转换结果不是object';
                }
            } catch (error) {
                if (isthrow) throw new Error(this + '不是json格式的字符串');
            }
            return json_data;
        };
        String.prototype.count = function (text) {
            if (this.includes(text))
                return this.split(text).length - 1;
            else
                return 0;
        };
        String.prototype.capitalize = function () {
            if (this == '') return this;
            else return this.charAt(0).toUpperCase() + this.slice(1).toLowerCase();
        };
        String.prototype.clear = function () {
            return this.replace(/^\s+|\s+$/g, '').replace(/\s+/g, ' ');
        };
        String.prototype.insert = function (text, at) {
            if (at == null || at > this.length)
                at = this.length;
            else if (at < 0)
                at = 0;

            return this.substring(0, at) + text + this.substring(at);
        };
        String.prototype.replaceAll = function (reallyDo, replaceWith, ignoreCase) {
            if (!RegExp.prototype.isPrototypeOf(reallyDo)) {
                return this.replace(new RegExp(reallyDo, (ignoreCase ? 'gi' : 'g')), replaceWith);
            } else {
                return this.replace(reallyDo, replaceWith);
            }
        };
        //16进制的字符串转字符串
        String.prototype.hexToStr = function () {
            var trimedStr = this.trim();
            trimedStr = trimedStr.replace(new RegExp(' ', 'g'), '');
            trimedStr = trimedStr.replace(new RegExp('0x', 'g'), '');
            var rawStr =
                trimedStr.substr(0, 2).toLowerCase() === '0x'
                    ?
                    trimedStr.substr(2)
                    :
                    trimedStr;
            var len = rawStr.length;
            if (len % 2 !== 0) {
                alert('Illegal Format ASCII Code!');
                return '';
            }
            var curCharCode;
            var resultStr = [];
            for (var i = 0; i < len; i = i + 2) {
                curCharCode = parseInt(rawStr.substr(i, 2), 16); // ASCII Code Value
                resultStr.push(String.fromCharCode(curCharCode));
            }
            return resultStr.join('');
        };
        //gbk长度,汉字2字节
        String.prototype.gbklen = function () {
            var len = 0;
            for (var i = 0; i < this.length; i++) {
                if (this.charCodeAt(i) > 127 || this.charCodeAt(i) == 94) {
                    len += 2;
                } else {
                    len++;
                }
            }
            return len;
        };
        //从1开始
        //开始位置在中文的一半,向前一位   "中华人民共和国"    cutstr(str,2,2) =中
        //后面长度在中文的一半,向前一位   "中华人民共和国"    cutstr(str,1,3) =中
        //返回数据长度<=len
        String.prototype.gbksubstr = function (start, len) {
            let str = this;
            if (start < 1) start = 1;
            let end = start + len - 1;
            let str_index = 0;
            let str_cut = '';

            let str_len = 0;
            for (var i = 0; i < str.length; i++) {
                let a = str.charAt(i);
                let a_len = escape(a).length > 4 ? 2 : 1;  //中文字符的长度经编码之后大于4
                str_index = str_index + a_len;

                if (str_index < start) continue;

                if (str_index <= end) {
                    str_len = str_len + a_len;
                    if (str_len <= len) str_cut = str_cut.concat(a);
                }
                if (str_index >= end || str_len >= len) {
                    return str_cut;
                }
            }
            //如果给定字符串小于指定长度，则返回源字符串；
            if (str_index < end) {
                return str_cut;
            }
        };
        String.prototype.toNumber = function () {
            let tmp = parseFloat(this);
            if (Number.isNaN(tmp)) tmp = 0;
            return tmp;
        }

        String.prototype.toFixed = function (x) {
            let str = this;
            return parseFloat(str).toFixed(x);
        }

        String.prototype.toDate = function () {
            try {
                //20200629110230
                let val = this;
                let tmp = new Date(val);
                if (new RegExp(/^([1-9]\d{3})(0[1-9]|1[0-2])(0[1-9]|[1-2][0-9]|3[0-1])$/).test(val.toString())) {
                    let tmp = new RegExp(/^([1-9]\d{3})(0[1-9]|1[0-2])(0[1-9]|[1-2][0-9]|3[0-1])$/).exec(val.toString());
                    tmp = new Date(tmp[1], parseInt(tmp[2]) - 1, tmp[3]);
                }
                else if (new RegExp(/^([1-9]\d{3})(0[1-9]|1[0-2])(0[1-9]|[1-2][0-9]|3[0-1])(0[0-9]|1[0-9]|2[0-3])([0-5][0-9])([0-5][0-9])$/).test(val.toString())) {
                    let tmplist = new RegExp(/^([1-9]\d{3})(0[1-9]|1[0-2])(0[1-9]|[1-2][0-9]|3[0-1])(0[0-9]|1[0-9]|2[0-3])([0-5][0-9])([0-5][0-9])$/).exec(val.toString());
                    tmp = new Date(tmplist[1], parseInt(tmplist[2]) - 1, tmplist[3], tmplist[4], tmplist[5], tmplist[6]);
                }
                if (tmp == 'Invalid Date') tmp = '';
                return tmp;
            } catch (error) {
                return;
            }
        }

        String.prototype.trim = function (char) {
            if (char) return this.replace(new RegExp('^\\' + char + '+|\\' + char + '+$', 'g'), '');
            return this.replace(/^\s+|\s+$/g, '');
        };

        String.prototype.trimStart = function (char) {
            if (char) return this.replace(new RegExp('^\\' + char + '+', 'g'), '');
            return this.replace(/^\s+/g, '');
        }
        String.prototype.trimEnd = function (char) {
            if (char) return this.replace(new RegExp('\\' + char + '+$', 'g'), '');
            return this.replace(/\s+$/g, '');
        }
        //这个跟cypto中有冲突
        // String.prototype.padding = function (length) {
        //     return (Array(length).join("0") + this).slice(-length);;
        // }

        String.prototype.toMoney = function (n) {
            let val = this;
            val = parseFloat(val);
            return val.toMoney(n);
        }
        String.prototype.includesCount = function (substr) {
            return this.split(substr).length - 1;
        }
    }

    //日期
    {
        Date.isLeepYear = function (year) {
            return (year % 4 == 0 && year % 100 != 0);
        };
        Date.prototype.isLeepYear = function () {
            let year = this.getFullYear();
            return (year % 4 == 0 && year % 100 != 0);
        };
        Date.daysInMonth = function (year, month) {
            if (month == 2) {
                if (year % 4 == 0 && year % 100 != 0)
                    return 29;
                else
                    return 28;
            }
            else if ((month <= 7 && month % 2 == 1) || (month > 7 && month % 2 == 0))
                return 31;
            else
                return 30;
        };

        Date.prototype.add = function (milliseconds) {
            var m = this.getTime() + milliseconds;
            return new Date(m);
        };
        Date.prototype.addSeconds = function (second) {
            return this.add(second * 1000);
        };
        Date.prototype.addMinutes = function (minute) {
            return this.addSeconds(minute * 60);
        };
        Date.prototype.addHours = function (hour) {
            return this.addMinutes(60 * hour);
        };
        Date.prototype.addDays = function (day) {
            return this.addHours(day * 24);
        };
        Date.prototype.addMonth = function () {
            console.log('addMonth这个函数即将废弃,请使用addMonths(1)代替');
            var m = this.getMonth();
            if (m == 11) return new Date(this.getFullYear() + 1, 0, this.getDate(), this.getHours(), this.getMinutes(), this.getSeconds());

            var daysInNextMonth = Date.daysInMonth(this.getFullYear(), this.getMonth() + 1);
            var day = this.getDate();
            if (day > daysInNextMonth) {
                day = daysInNextMonth;
            }
            return new Date(this.getFullYear(), this.getMonth() + 1, day, this.getHours(), this.getMinutes(), this.getSeconds());
        };
        Date.prototype.subMonth = function () {
            console.log('subMonth这个函数即将废弃,请使用addMonths(-1)代替');
            var m = this.getMonth();
            if (m == 0) return new Date(this.getFullYear() - 1, 11, this.getDate(), this.getHours(), this.getMinutes(), this.getSeconds());
            var day = this.getDate();
            var daysInPreviousMonth = Date.daysInMonth(this.getFullYear(), this.getMonth());
            if (day > daysInPreviousMonth) {
                day = daysInPreviousMonth;
            }
            return new Date(this.getFullYear(), this.getMonth() - 1, day, this.getHours(), this.getMinutes(), this.getSeconds());
        };
        Date.prototype.addMonths = function (addMonth) {
            var result = this;
            if (addMonth > 0) {
                while (addMonth > 0) {
                    result = result.addMonth();
                    addMonth--;
                }
            } else if (addMonth < 0) {
                while (addMonth < 0) {
                    result = result.subMonth();
                    addMonth++;
                }
            }
            return result;
        };
        Date.prototype.addYears = function (year) {
            return new Date(this.getFullYear() + year, this.getMonth(), this.getDate(), this.getHours(), this.getMinutes(), this.getSeconds());
        };
        Date.prototype.format = function (format) {
            format = format || 'yyyy/MM/dd hh:mm:ss';
            var o = {
                'M+': this.getMonth() + 1, //month
                'd+': this.getDate(),    //day
                'h+': this.getHours(),   //hour
                'm+': this.getMinutes(), //minute
                's+': this.getSeconds(), //second
                'q+': Math.floor((this.getMonth() + 3) / 3),  //quarter
                'S': this.getMilliseconds() //millisecond
            };
            if (/(y+)/.test(format)) format = format.replace(RegExp.$1,
                (this.getFullYear() + '').substr(4 - RegExp.$1.length));
            for (var k in o) if (new RegExp('(' + k + ')').test(format))
                format = format.replace(RegExp.$1,
                    RegExp.$1.length == 1 ? o[k] :
                        ('00' + o[k]).substr(('' + o[k]).length));
            return format;
        };
        Date.prototype.firstdate = function () {
            var year = this.getFullYear();
            var month = this.getMonth() + 1;
            return (new Date(year + '/' + month + '/01'));
        };
        Date.prototype.lastdate = function () {
            return this.firstdate().addMonth().addDays(-1);
        };
        Date.prototype.yearfirstdate = function () {
            var year = this.getFullYear();
            var month = 1;
            return (new Date(year + '/' + month + '/01'));
        };
        Date.prototype.yearlastdate = function () {
            return this.yearfirstdate().addYears(1).addDays(-1);
        };
        Date.prototype.date = function () {
            return new Date(this.getFullYear(), this.getMonth(), this.getDate());
        };

        Date.prototype.dayStart = function (hour = 0) {
            let that = this;
            if (that.getHours() < hour) that = that.addDays(-1);
            return new Date(that.format('yyyy/MM/dd') + ' ' + hour + ':00:00');
        }
        Date.prototype.dayEnd = function (hour = 0) {
            let that = this;
            if (that.getHours() < hour) that = that.addDays(-1);
            return new Date(that.format('yyyy/MM/dd') + ' ' + hour + ':00:00').addDays(1).addSeconds(-1);
        }
        Date.prototype.monthDayStart = function (day = 1, hour = 0) {
            let that = this;
            if (that.getHours() < hour) that = that.addDays(-1);
            if (that.getDate() < day) that = that.addMonths(-1);
            return new Date(that.format('yyyy/MM/') + day + ' ' + hour + ':00:00');
        }
        Date.prototype.monthDayEnd = function (day = 1, hour = 0) {
            let that = this;
            if (that.getHours() < hour) that = that.addDays(-1);
            if (that.getDate() < day) that = that.addMonth(-1);
            return new Date(that.format('yyyy/MM/') + day + ' ' + hour + ':00:00').addMonth(1).addSeconds(-1);
        }
        Date.prototype.monthStart = function (day = 1) {
            let that = this;
            if (that.getDate() < day) that = that.addMonths(-1);
            return new Date(that.format('yyyy/MM/') + day);
        }
        Date.prototype.monthEnd = function (day = 1) {
            let that = this;
            if (that.getDate() < day) that = that.addMonths(-1);
            return new Date(that.format('yyyy/MM/') + day).addMonths(1).addDays(-1);
        }
        Date.prototype.yearDayStart = function (hour = 0) {
            let that = this;
            if (that.getMonth() == 0 && that.getHours() < hour) that = that.addDays(-1);
            var year = that.getFullYear();
            var month = 1;
            return (new Date(year + '/' + month + '/01' + ' ' + hour + ':00:00'));
        };
        Date.prototype.yearDayEnd = function (hour = 0) {
            return this.yearDayStart(hour).addYears(1).addSeconds(-1);
        };
        Date.prototype.getFullMonth = function () {
            return new Date(this).getMonth() + 1;
        };
        Date.prototype.isValidDate = function () {
            return this instanceof Date && !isNaN(this.getTime())
        }
    }

    //数组部分扩展
    {
        Array.prototype.removeAll = function (e) {
            if (typeof eval != 'undefined' && typeof e == 'string') {
                let index = this.findIndex($ => eval(e));
                while (index > -1) {
                    this.splice(index, 1);
                    index = this.findIndex($ => eval(e));
                }
            } else {
                let index = linq.from(this).indexOf(e);
                while (index > -1) {
                    this.splice(index, 1);
                    index = linq.from(this).indexOf(e);
                }
            }
        };
        Array.prototype.Sum = function (e) { return linq.from(this).sum(e); };
        Array.prototype.Where = function (e) { return linq.from(this).where(e).toArray(); };
        Array.prototype.Count = function (e) { return linq.from(this).count(e); };
        Array.prototype.Any = function (e) { return linq.from(this).any(e); };
        Array.prototype.Remove = function (obj) {
            for (var i = 0; i < this.length; i++) {
                var temp = this[i];
                if (!isNaN(obj)) {
                    temp = i;
                }
                if (temp == obj) {
                    for (var j = i; j < this.length; j++) {
                        this[j] = this[j + 1];
                    }
                    this.length = this.length - 1;
                }
            }
        };
        Array.prototype.FirstOrDefault = function (e) { return linq.from(this).firstOrDefault(e, undefined); };
        Array.prototype.Select = function (e) { return linq.from(this).select(e).toArray(); };
        Array.prototype.OrderBy = function (e) { return linq.from(this).orderBy(e).toArray(); };
        Array.prototype.OrderByDescending = function (e) { return linq.from(this).orderByDescending(e).toArray(); };
        Array.prototype.Max = function (e) {
            if (this.length < 1) return null;
            return linq.from(this).max(e);
        }
        Array.prototype.Min = function (e) {
            if (this.length < 1) return null;
            return linq.from(this).min(e);
        }
        Array.prototype.GroupBy = function (a, b = null, c, d = null) {
            c = c || ((key, mx) => { return { key, mx: mx.toArray() } });
            return linq.from(this).groupBy(a, b, c, d).toArray();
        }
        Array.prototype.InArray = function (e) {
            if (!e) return false;
            for (let index = 0; index < this.length; index++) {
                const a = this[index];
                if (e.indexOf(a) < 0) return false;
            }
            return true;
        }
        Array.prototype.LastOrDefault = function (a, b) {
            return linq.from(this).lastOrDefault(a, b);
        }

        Array.prototype.IndexOf = function (e) { return linq.from(this).indexOf(e); };

        Array.prototype.Replace = function (e, b) {
            let index = this.IndexOf(e);
            if (index > -1) {
                if (typeof b == 'undefined') this.splice(index, 1);
                else this.splice(index, 1, b);
            }
        }
    }

    //数字
    {
        Number.prototype.toNumber = function () {
            let tmp = parseFloat(this);
            if (Number.isNaN(tmp)) tmp = 0;
            return tmp;
        }
        Number.prototype.Padding = function (length) {
            let num = this;
            for (var len = (num + "").length; len < length; len = num.length) {
                num = "0" + num;
            }
            return num.toString();
        }
        Number.prototype.padding = function (length) {
            return (Array(length).join("0") + this).slice(-length);
        }
        global.isNumber = function (a) {
            return typeof a === "number" && !Number.isNaN(a);
        }
        Math.Round = function (n = 0, b = 2) {
            var tmp = Math.pow(10, b);
            return Math.round((n || 0) * (tmp * 10) / 10) / tmp; //js精度损失问题  0.285*100=28.4999999    0.285*1000/10 =28.5
        }


        Number.prototype.toMoney = function (n) {
            let val = this;
            try {
                if (typeof val == "string") val = parseFloat(val);
                val = val || 0;
                if (typeof n == "undefined") n = 2;
                n = n >= 0 && n <= 20 ? n : 2;
                val = parseFloat((val + "").replace(/[^\d\.-]/g, "")).toFixed(n) + "";
                var l = val.split(".")[0].split("").reverse(),
                    r = val.split(".")[1] || '';
                let t = "";
                for (let i = 0; i < l.length; i++) {
                    t += l[i] + ((i + 1) % 4 == 0 && (i + 1) != l.length ? "'" : "");
                }
                return t.split("").reverse().join("") + (r ? "." : '') + r;
            } catch (error) {
                return '';
            }
        }

    }

    //重写JSON.parse,解析json的时候把时间的字符串类型解析成日期类型
    if (!JSON.parse2) {
        JSON.parse2 = JSON.parse;
        JSON.parse = function (str, fun) {
            try {
                if (!str) return str;
                return JSON.parse2(str, function (key, value) {
                    if (fun)
                        return fun(key, value);
                    var a;
                    if (typeof value === 'string') {
                        a = /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2}):(\d{2}(?:\.\d*)?)Z$/.exec(value);
                        if (a) {
                            return new Date(value);
                        }
                    }
                    return value;
                });
            } catch (error) {
                return str;
            }
        }
    }
    JSON.tryParse = function (str) {
        let jo = null;
        try {
            jo = JSON.parse(str);
        } catch (error) {
            //
        }
        return jo
    }
    JSON.check = function (data, rules) {
        if (Array.isArray(rules)) {
            for (let i = 0; i < rules.length; i++) {
                const 源值 = rules[i];
                const 目标值 = data[i];
                if (目标值 === undefined) {
                    data[i] = 源值;
                } else if (Array.isArray(源值)) {
                    if (Array.isArray(目标值)) {
                        JSON.check(目标值, 源值);
                    } else {
                        data[i] = 源值;
                    }
                } else if (typeof 源值 === 'object') {
                    if (typeof 目标值 === 'object') {
                        JSON.check(目标值, 源值);
                    } else {
                        data[i] = 源值;
                    }
                }
            }
        } else if (typeof rules === 'object') {
            for (const key in rules) {
                const 源值 = rules[key];
                const 目标值 = data[key];
                if (目标值 === undefined) {
                    data[key] = 源值;
                } else if (Array.isArray(源值)) {
                    if (Array.isArray(目标值)) {
                        JSON.check(目标值, 源值);
                    } else {
                        data[key] = 源值;
                    }
                } else if (typeof 源值 === 'object') {
                    if (typeof 目标值 === 'object') {
                        JSON.check(目标值, 源值);
                    } else {
                        data[key] = 源值;
                    }
                }
            }
        }
        return data;
    }

    //全局扩展
    global.isEmpty = function (a) {
        return typeof a === "undefined" || a == null || a === '';
    }
    global.isundefined = function (a) {
        return typeof a === "undefined" || a === '';
    }
    global.isNumber = function (a) {
        return typeof a === "number" && !Number.isNaN(a);
    }
    global.tryParseFloat = function (a) {
        return parseFloat(a) || 0;
    }
    global.tryParseInt = function (a) {
        return parseInt(a) || 0;
    }
    global.delay = function (time) {
        time = time || 1000;
        return new Promise((resolve, reject) => {
            try {
                setTimeout(() => {
                    resolve('延时' + time + 'ms');
                }, time);
            } catch (error) {
                reject(error);
            }
        });
    };
};

